export default 'DUCKS/SEARCH';
